<template>
  <a class="c-car-thumb-link" :href="carHref">
    <el-card class="c-car-thumb" :body-style="{ padding: '0px' }" shadow="hover">
      <!-- <div class="c-car-thumb"> -->
      <!-- <div class="c-car-thumb__img" :style="'background-image: url(' + imageUrl + carImages[0] + ')'"></div>        -->
      <div class="c-car-thumb__img-wrapper">
        <img
          v-if="carImages[0]"
          class="c-car-thumb__img"
          :src="imageUrl + carImages[0]"
          alt=""
          loading="lazy"
        />
      </div>
      <!-- <img class="c-car-thumb__img" :src="carImages[0]" alt="" /> -->
      <div class="c-car-thumb__content">
        <div class="c-car-thumb__title">
          <template v-if="car['Name Marke'] != 'Fremdmarke'">{{
            car["Name Marke"]
          }}</template>
          {{ car["Name Modell Type"] }}
        </div>
        <el-row>
          <el-col :sm="12"> {{ car["KW"] | ps }} PS </el-col>
          <el-col :sm="12">
            {{ formatDate(car["Erstzulassung"]) }}
          </el-col>
          <el-col :sm="12"> {{ car["KM"] | dot }} km<br /> </el-col>
          <el-col :sm="12"> {{ car["Fahrzeugtyp-ID"] }}<br /> </el-col>
          <el-col :sm="12" v-if="locationName"> {{ locationName }}<br /> </el-col>
        </el-row>
        <div class="c-car-thumb__price">
          {{ this.$options.filters.currency(car["Preis"]) }}
        </div>
        <!-- <el-button
                  type="primary"
                  @click="
                      $router.push({
                          name: 'fahrzeug',
                          params: { id: car['Fahrzeug-ID'] }
                      })
                  "
                  >Mehr Infos</el-button
              > -->
      </div>
      <!-- </div> -->
    </el-card>
  </a>
</template>

<script>
// import { checkImageExists } from "@/utils/imagecheck";
import { DateFormatter } from "@/utils/date";

export default {
  name: "CarThumb",
  props: {
    carId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMAGEURL,
      // carImages: []
    };
  },
  watch: {
    // car() {
    //     this.fillCarImages();
    // }
  },
  mounted() {
    // this.fillCarImages();
  },
  computed: {
    car() {
      return this.$store.state.cars.all[this.carId];
    },
    locationName() {
      const isRdw = [
        "rdw.cc",
        "www.rdw.cc",
        "neu.rdw.cc",
        "localhost",
      ].includes(window.location.hostname);
      const isAutoebner = ["autoebner.at", "www.autoebner.at"].includes(
        window.location.hostname,
      );
      if ((!isRdw && !isAutoebner) || !this.car["Händler-ID"]) return null;
      let map = {};
      if (isRdw) {
        map = { "18": "Währing", "21": "Leopoldau" };
      } else if (isAutoebner) {
        // TODO: check Händler-ID numbers in https://www.autoebner.at/fsales/dist/api/?Function=getCars (currently empty)
        map = {
          "13": "Brunn am Gebirge",
          "20": "Perchtoldsdorf",
          "02": "Baden",
          "12": "Oeynhausen",
          "11": "Felixdorf",
          "17": "Wr. Neustadt",
          "01": "Eisenstadt",
        };
      }
      return map[this.car["Händler-ID"]] || null;
    },
    carImages() {
      let result = [];
      if (Array.isArray(this.car.Bild)) {
        result = this.car.Bild;
      }
      return result;
    },
    carHref() {
      return this.$router.resolve({ name: "fahrzeug", params: { id: this.carId } })
        .href;
    },
  },
  methods: {
    // fillCarImages() {
    //     this.carImages = [];
    //     let imageUrl =
    //         process.env.VUE_APP_IMAGEURL +
    //         this.car["Fahrzeug-ID"] +
    //         "_1.jpg";
    //     checkImageExists(imageUrl, imgUrl => {
    //         if (imgUrl) {
    //             this.carImages.push(imgUrl);
    //         } else {
    //             this.carImages.push("./placeholder_car.jpg");
    //         }
    //         this.carImages.sort();
    //     });
    // },
    formatDate(dateString) {
      if (dateString == null) {
        return "k.A.";
      }
      return DateFormatter.formatDate(new Date(dateString), "MM.YYYY");
    },
  },
};
</script>

<style scoped lang="scss">
.c-car-thumb-link {
  display: block;
  color: inherit;
  text-decoration: none;
}
.c-car-thumb {
  // border: solid 2px green;
  // padding: 0;
  margin-bottom: 20px;
  cursor: pointer;

  &:hover {
    transform: scale(1.04);
  }
  &__title {
    font-size: medium;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &__price {
    margin-top: 10px;
    font-size: large;
    font-weight: bold;
  }
  &__content {
    padding: 10px;
  }
  // &__img {
  //   width: 100%;
  //   height: 281px;
  //   background-size: cover;
  //   background-position: center center;
  // }
  .el-button {
    width: 100%;
  }
}
.c-car-thumb__img-wrapper {
  width: 100%;
  height: 281px;
  overflow: hidden;
}
.c-car-thumb__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
